import HeaderSearchController from './headerSearch';

export default class HeaderController {
	constructor() {
		this.headerElement = null;
		this.menuButton = null;

		this.previousScroll = 0;
		this.scrollCounter = 0;
		this.threshold = 500;

		this.init();
		this.resize();

		this.headerSearchController = new HeaderSearchController();
	}

	init() {
		this.headerElement = document?.querySelector('header');
		this.menuButton = this.headerElement?.querySelector('.menuButton');
		this.previousScroll = window.pageYOffset;

		// Register events
		window.app.registerResizeEvent(this.resize.bind(this));
		window.app.registerScrollEvent(this.scroll.bind(this));

		// Click events
		this.menuButton?.addEventListener('click', this.toggleMenu.bind(this));
	}

	toggleMenu() {
		this.headerElement.classList.toggle('mobileMenuActive');
	}

	resize() {
		this.previousScroll = window.pageYOffset;
		this.threshold = this.headerElement?.clientHeight;

		this.scroll();
	}

	scroll() {
		// First, decide if it's up or down
		if (this.previousScroll > window.pageYOffset) {
			// Up
			if (this.scrollCounter > 0) {
				this.scrollCounter = 0;
			}

			this.scrollCounter += window.pageYOffset - this.previousScroll;
		} else if (this.previousScroll < window.pageYOffset) {
			// Down
			if (this.scrollCounter < 0) {
				this.scrollCounter = 0;
			}

			this.scrollCounter += window.pageYOffset - this.previousScroll;
		}

		if (window.pageYOffset < this.threshold) {
			this.show();
		} else {
			if (this.scrollCounter > this.threshold) {
				this.hide();
			}
	
			if (this.scrollCounter < this.threshold * -1) {
				this.show();
			}
		}

		this.previousScroll = window.pageYOffset;
	}

	hide() {
		this.headerElement?.classList.add('hidden');
	}

	show() {
		this.headerElement?.classList.remove('hidden');
	}
}